"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __sfc_main = {};
__sfc_main.props = {
    list: {
        key: "list",
        required: true,
        type: Array
    },
    handleClick: {
        key: "handleClick",
        required: true,
        type: Function
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const props = __props;
    function formatText(text) {
        return text.replace(/{(.*)}/g, '<span>$1</span>');
    }
    return {
        props,
        formatText
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXgudnVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaW5kZXgudnVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBTSxVQUFVLEdBQUcsRUFBRSxDQUFDO0FBQ3RCLFVBQVUsQ0FBQyxLQUFLLEdBQUc7SUFDakIsSUFBSSxFQUFFO1FBQ0osR0FBRyxFQUFFLE1BQU07UUFDWCxRQUFRLEVBQUUsSUFBSTtRQUNkLElBQUksRUFBRSxLQUFLO0tBQ1o7SUFDRCxXQUFXLEVBQUU7UUFDWCxHQUFHLEVBQUUsYUFBYTtRQUNsQixRQUFRLEVBQUUsSUFBSTtRQUNkLElBQUksRUFBRSxRQUFRO0tBQ2Y7Q0FDRixDQUFDO0FBQ0YsVUFBVSxDQUFDLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUUsRUFBRTtJQUNwQyxNQUFNLEtBQUssR0FBRyxPQUFPLENBQUM7SUFDdEIsU0FBUyxVQUFVLENBQUMsSUFBWTtRQUM5QixPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsU0FBUyxFQUFFLGlCQUFpQixDQUFDLENBQUM7SUFDcEQsQ0FBQztJQUNELE9BQU87UUFDTCxLQUFLO1FBQ0wsVUFBVTtLQUNYLENBQUM7QUFDSixDQUFDLENBQUM7QUFDRixrQkFBZSxVQUFVLENBQUMifQ==